// Форматирование чисел/денег (перенос из демо).
export const fmt = (n: number): string =>
  Math.round(n || 0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const money = (n: number): string => fmt(n) + ' ₸';

const MONTHS_SHORT = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек',
];
// 'YYYY-MM-DD' → '10 авг 26'. Пустая/битая дата → '—'.
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS_SHORT[m - 1] ?? ''} ${String(y).slice(2)}`;
}

// Разбить сумму по долям: последний транш добирает остаток (Σ = сумме ровно).
// Зеркалит серверный splitByPct — для предпросмотра сумм пресета в карточке.
export function splitByPct(sum: number, pcts: number[]): number[] {
  const amounts = pcts.map((p) => Math.round((sum * p) / 100));
  if (amounts.length > 0) {
    const rest = amounts.slice(0, -1).reduce((a, b) => a + b, 0);
    amounts[amounts.length - 1] = sum - rest;
  }
  return amounts;
}

export const mln = (n: number): string => {
  n = n || 0;
  if (n >= 1e9) return (n / 1e9).toFixed(n >= 1e10 ? 0 : 2).replace(/\.?0+$/, '') + ' млрд';
  if (n >= 1e6) return fmt(Math.round(n / 1e6)) + ' млн';
  return fmt(n);
};
